import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { 
  faInfoCircle, faTimes, faClock, faSpinner, faCheck, faBan, faExclamationTriangle, faBan as faBanIcon
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-modal-task-details',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule],
  templateUrl: './modal-task-details.component.html',
  styleUrls: ['./modal-task-details.component.scss']
})
export class ModalTaskDetailsComponent {
  @Input() task: any;
  @Output() close = new EventEmitter<void>();

  faInfoCircle = faInfoCircle;
  faTimes = faTimes;
  faClock = faClock;
  faSpinner = faSpinner;
  faCheck = faCheck;
  faBan = faBan;

  getStatusClass(status: string): string {
    const statusMap: { [key: string]: string } = {
      'PENDING': 'status-queued',
      'pending': 'status-queued',
      'RUNNING': 'status-running',
      'running': 'status-running',
      'COMPLETED': 'status-finished',
      'completed': 'status-finished',
      'FAILED': 'status-failed',
      'failed': 'status-failed',
      'CANCELLED': 'status-cancelled',
      'cancelled': 'status-cancelled'
    };
    return statusMap[status] || 'status-queued';
  }

  getStatusIcon(status: string): any {
    const iconMap: { [key: string]: any } = {
      'PENDING': faClock,
      'pending': faClock,
      'RUNNING': faSpinner,
      'running': faSpinner,
      'COMPLETED': faCheck,
      'completed': faCheck,
      'FAILED': faTimes,
      'failed': faTimes,
      'CANCELLED': faBan,
      'cancelled': faBan
    };
    return iconMap[status] || faClock;
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleString('pt-BR');
    } catch {
      return dateString;
    }
  }

  formatResult(result: any): string {
    if (!result) return 'N/A';
    try {
      return typeof result === 'string' ? result : JSON.stringify(result, null, 2);
    } catch {
      return String(result);
    }
  }

  onClose(): void {
    this.close.emit();
  }
}
